import * as React from "react";
const SvgFiRrBacon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bacon_svg__a)">
      <path
        fill="#062147"
        d="M23.088 4.75 19.153.817A2.764 2.764 0 0 0 14.472 2.3a2.54 2.54 0 0 1-2.186 2.187 3.286 3.286 0 0 0-2.807 2.805 2.54 2.54 0 0 1-2.187 2.187 3.286 3.286 0 0 0-2.806 2.807 2.5 2.5 0 0 1-.721 1.465 2.55 2.55 0 0 1-1.51.727 2.58 2.58 0 0 0-2.108 1.785 2.8 2.8 0 0 0 .668 2.889L4.76 23.1c1.334 1.366 3.25 1.035 4.65-.033a5.6 5.6 0 0 0 2.425-1.243 4.5 4.5 0 0 0 1.29-2.624 1.28 1.28 0 0 1 1.074-1.08 4.546 4.546 0 0 0 3.916-3.915 1.28 1.28 0 0 1 1.084-1.078 4.58 4.58 0 0 0 3.846-3.642q.102-.262.25-.5a3.173 3.173 0 0 0-.208-4.234M2.044 16.9a.61.61 0 0 1 .509-.44 4.5 4.5 0 0 0 2.627-1.29 4.5 4.5 0 0 0 1.289-2.63 1.28 1.28 0 0 1 1.077-1.078 4.54 4.54 0 0 0 3.916-3.916 1.28 1.28 0 0 1 1.078-1.077 4.54 4.54 0 0 0 3.918-3.931.75.75 0 0 1 1.282-.307l1.29 1.29c-1.355.882-.917 2.547-1.937 3.586a2.5 2.5 0 0 1-1.466.72 3.286 3.286 0 0 0-2.806 2.807 2.53 2.53 0 0 1-2.188 2.186 3.29 3.29 0 0 0-2.806 2.807 2.5 2.5 0 0 1-.721 1.466C6.07 18.11 4.4 17.68 3.522 19.03L2.23 17.739a.82.82 0 0 1-.186-.84m19.673-9.141a6.6 6.6 0 0 0-.585 1.14 2.57 2.57 0 0 1-2.19 2.245 3.29 3.29 0 0 0-2.806 2.806 2.54 2.54 0 0 1-2.186 2.187 3.284 3.284 0 0 0-2.806 2.806 2.5 2.5 0 0 1-.722 1.466c-.661.638-1.9.643-2.643 1.31-1.185.936-2.066-.586-2.824-1.255A1.28 1.28 0 0 1 5.9 19.8a4.544 4.544 0 0 0 3.916-3.915 1.28 1.28 0 0 1 1.072-1.085 4.53 4.53 0 0 0 3.917-3.916 1.28 1.28 0 0 1 1.076-1.077A4.55 4.55 0 0 0 19.8 5.9a1.28 1.28 0 0 1 .666-.94c.662.748 2.174 1.627 1.25 2.799"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bacon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBacon;
